import React from 'react';
import { connect } from 'react-redux';
import { appConfig } from '@config';

import "./styles.scss";

import Input from '@components/Input';
import { prepareNum, unitLabel, unitTransform } from '@services/helper.service';

import {
  setMasonryType,
  setCompressiveStrength,
  setMasonryImage,
  setMasonryLength,
  setMasonryWidth,
  setMasonryHeight
} from '@reducers/selectors/material/actions';

import { defaultUnits } from '@config';
import { APP_TEXTS } from '../../../../../../texts/texts';
import { setGroundOptions } from '@reducers/options/ground/actions';

// eslint-disable-next-line react/prefer-stateless-function
class SpitTech extends React.Component {

  render () {
    return (
      <div>
        <div className="list-type masonry-spit-tech">
          <h4>{APP_TEXTS.TYPE_OF_MASONRY_LABEL.Content}</h4>
          <label htmlFor="type-of-masonry">
            <select
              className="form-control"
              id="type-of-masonry"
              defaultValue={this.props.masonryType}
              onChange={async e => {
                await this.props.setMasonryType(e.target.value);
              }}
            >
              {this.props.masonryTypes.length && this.props.masonryTypes.map(({InternalName, RunName}) => (
                <option key={InternalName} value={InternalName}>{RunName}</option>
              ))}
            </select>
          </label>
        </div>

        {this.props.imageLink && (
          <div className="list-type">
            <img src={appConfig.BASE_URL + this.props.imageLink} alt={APP_TEXTS.IMAGE_OF_THE_BLOCK_SELECTED.Content}/>
          </div>
        )}

        <div className="list-type masonry-spit-tech">
          <h4>{APP_TEXTS.CHARACTERISTICS_MASONRY_UNITS_LABEL.Content}</h4>

          <Input
            disabled={true}
            prefix={APP_TEXTS.COMPRESSIVE_STRENGTH_LABEL.Content}//"Compressive strength"
            postfix={<span>{unitLabel(this.props.strengthUnit)}</span>}
            id="compressive-strength"
            type="number"
            value={prepareNum(
              unitTransform(this.props.compressiveStrength || 0).from(defaultUnits.STRENGTH).to(this.props.strengthUnit), 
              false, 
              0
            )}
            onUpdate={value => {
              this.props.setCompressiveStrength(
                unitTransform(value, false).from(this.props.strengthUnit).to(defaultUnits.STRENGTH)
              );
            }}
          />

          <Input
            disabled={true}
            prefix={APP_TEXTS.LENGTH_LABEL.Content}//"Length"
            postfix={unitLabel(this.props.distanceUnit)}
            id="length"
            type="number"
            value={prepareNum(unitTransform(this.props.length || 0).from(defaultUnits.DISTANCE).to(this.props.distanceUnit), false, 0)}
            onUpdate={value => {
              this.props.setLength(
                unitTransform(value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
              );
            }}
          />

          <Input
            disabled={true}
            prefix={APP_TEXTS.WIDTH_LABEL.Content}//"Width"
            postfix={unitLabel(this.props.distanceUnit)}
            id="width"
            type="number"
            value={prepareNum(unitTransform(this.props.width || 0).from(defaultUnits.DISTANCE).to(this.props.distanceUnit), false, 0)}
            onUpdate={value => {
              this.props.setWidth(
                unitTransform(value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
              );
            }}
          />

          <Input
            disabled={true}
            prefix={APP_TEXTS.HEIGHT_LABEL.Content}//"Height"
            postfix={unitLabel(this.props.distanceUnit)}
            id="height"
            type="number"
            value={prepareNum(unitTransform(this.props.height || 0).from(defaultUnits.DISTANCE).to(this.props.distanceUnit), false, 0)}
            onUpdate={value => {
              this.props.setHeight(
                unitTransform(value, false).from(this.props.distanceUnit).to(defaultUnits.DISTANCE)
              );
            }}
          />
        </div>
      </div>
    );
  }
    
}

const mapState = state => {
  if (state.selectors.material[state.main.appType].hasOwnProperty('masonry') && 
    state.selectors.material[state.main.appType].masonry.hasOwnProperty('characteristicsMasonryUnits'))
    return { 
      temperatureUnit: state.main.units.temperature,
      loadUnit: state.main.units.load,
      strengthUnit: state.main.units.strength,
      distanceUnit: state.main.units.distance,

      masonryTypes: state.webServices.material.masonryTypes,

      masonryType: state.selectors.material[state.main.appType].masonry.characteristicsMasonryUnits.masonryType,

      compressiveStrength: state.selectors.material[state.main.appType].masonry.characteristicsMasonryUnits.compressiveStrength,
      length: state.selectors.material[state.main.appType].masonry.characteristicsMasonryUnits.length,
      width: state.selectors.material[state.main.appType].masonry.characteristicsMasonryUnits.width,
      height: state.selectors.material[state.main.appType].masonry.characteristicsMasonryUnits.height,
      imageLink: state.selectors.material[state.main.appType].masonry.characteristicsMasonryUnits.imageLink
    };
  else
    return {};
};

const mapDispatch = dispatch => ({
  setMasonryType: value => dispatch(setMasonryType(value)),
  setCompressiveStrength: value => dispatch(setCompressiveStrength(value)),
  setLength: value => dispatch(setMasonryLength(value)),
  setWidth: value => dispatch(setMasonryWidth(value)),
  setHeight: value => dispatch(setMasonryHeight(value)),
  setImage: value => dispatch(setMasonryImage(value)),
  setTextureColor: value => dispatch(setGroundOptions({ masonryTextureColor: value }))
});

export default connect(mapState, mapDispatch)(SpitTech);



// WEBPACK FOOTER //
// ./src/views/Material/components/Masonry/components/SpitTech/index.js